import { ROUTES } from '../Routes/routes';

interface Args {
  page: string;
  internalReference: string;
}

export function getItineraryPageRouteForItineraryPage({
  page,
  internalReference,
}: Args) {
  return ROUTES.itinerary.replace(':internalReference', internalReference);
}
